// Comprehensive currency and country data for AI Predictor
// This file now uses real API data from backend

export const predictionPeriods = [
  { value: '7', label: '7 Days' },
  { value: '14', label: '14 Days' },
  { value: '30', label: '30 Days' },
  { value: '60', label: '2 Months' },
  { value: '90', label: '3 Months' },
  { value: '180', label: '6 Months' },
  { value: '365', label: '1 Year' },
];

export const regions = [
  { value: 'all', label: 'Anywhere' },
  { value: 'americas', label: 'Americas' },
  { value: 'europe', label: 'Europe' },
  { value: 'asia', label: 'Asia & Pacific' },
  { value: 'middleeast', label: 'Middle East & Africa' },
  { value: 'oceania', label: 'Oceania' },
  { value: 'africa', label: 'Africa' },
];

// Country flag emoji lookup
export const countryFlags = {
  'USD': '🇺🇸', 'EUR': '🇪🇺', 'GBP': '🇬🇧', 'JPY': '🇯🇵', 'CHF': '🇨🇭',
  'AUD': '🇦🇺', 'NZD': '🇳🇿', 'MXN': '🇲🇽', 'BRL': '🇧🇷', 'ARS': '🇦🇷',
  'CLP': '🇨🇱', 'COP': '🇨🇴', 'PEN': '🇵🇪', 'CNY': '🇨🇳', 'HKD': '🇭🇰',
  'TWD': '🇹🇼', 'SGD': '🇸🇬', 'KRW': '🇰🇷', 'INR': '🇮🇳', 'IDR': '🇮🇩',
  'MYR': '🇲🇾', 'THB': '🇹🇭', 'VND': '🇻🇳', 'PHP': '🇵🇭', 'PKR': '🇵🇰',
  'AED': '🇦🇪', 'SAR': '🇸🇦', 'QAR': '🇶🇦', 'KWD': '🇰🇼', 'BHD': '🇧🇭',
  'OMR': '🇴🇲', 'JOD': '🇯🇴', 'ILS': '🇮🇱', 'EGP': '🇪🇬', 'TRY': '🇹🇷',
  'ZAR': '🇿🇦', 'NGN': '🇳🇬', 'KES': '🇰🇪', 'GHS': '🇬🇭', 'MAD': '🇲🇦',
  'SEK': '🇸🇪', 'NOK': '🇳🇴', 'DKK': '🇩🇰', 'PLN': '🇵🇱', 'CZK': '🇨🇿',
  'HUF': '🇭🇺', 'RON': '🇷🇴', 'RUB': '🇷🇺', 'UAH': '🇺🇦', 'ISK': '🇮🇸',
  'FJD': '🇫🇯', 'XPF': '🇵🇫', 'default': '💱'
};

export const getFlag = (code) => countryFlags[code] || countryFlags.default;
